import { useState } from 'react';
import { Col, Row } from 'reactstrap';
import TableActions from 'components/layouts/table';
import CPFormTypeSelector from 'components/selectors/CPFormTypeSelector';
import Table, { useTable } from 'common/components/table';
import useDrawer from 'common/components/drawer/useDrawer';
import edit from 'assets/svg/actions/edit-empty.svg';
import Form from './Form';
import EnumsDropdown from '../Dropdown';

const CharterPartiesForms = () => {
  const [active, setActive] = useState(null);
  const drawer = useDrawer();
  const table = useTable({
    label: 'cp_forms',
    columns: [
      {
        header: 'Short Name',
        key: 'short_name',
        type: 'string',
        sort: true
      },
      {
        header: 'Full Name',
        key: 'full_name',
        type: 'string',
        sort: true
      },
      {
        header: 'Description',
        key: 'description',
        type: 'string',
        sort: true
      },
      {
        header: 'Type',
        key: 'type',
        type: 'collection',
        component: CPFormTypeSelector,
        componentRest: { isMulti: true },
        sort: true
      },
      {
        header: 'Actions',
        key: 'actions',
        field: 'actions',
        className: 'text-center',
        width: 1
      }
    ]
  });

  return (
    <Row className="cp-forms-table">
      <Col xs={12} className="mb-6 mt-n1">
        <TableActions
          documentTitle="CP-Forms"
          title="Enums"
          dropdown={<EnumsDropdown />}
          actions={[
            { type: 'search' },
            {
              type: 'add',
              text: 'Add CP Form',
              color: 'primary',
              onClick: () => {
                setActive(null);
                drawer.open();
              }
            }
          ]}
        />
      </Col>
      <Col xs={12}>
        <Table
          loader
          bulk
          bulkActions={[]}
          drawer={<Form drawer={drawer} refetchData={table.refetchData} active={active} />}
          rows={{
            full_name: data => data.full_name || '-',
            description: data => data.description || '-',
            type: data => <div>{data.type === 'V' ? 'VOYAGE' : 'TC'}</div>,
            actions: {
              options: [
                {
                  label: 'Edit',
                  icon: edit,
                  onClick: (_, row) => {
                    setActive(row);
                    drawer.open();
                  }
                }
              ]
            }
          }}
          {...table}
        />
      </Col>
    </Row>
  );
};

export default CharterPartiesForms;
